import React from 'react';
import { StyledMakeAppointmentStep } from './AppointmentStep.styles';

export const AppointmentStep: React.FC = (props) => {
    return <StyledMakeAppointmentStep {...props}/>
};
